import Vue from 'vue';
import VueStripeCheckout from 'vue-stripe-checkout';

Vue.use(VueStripeCheckout, {
  key:
    process.env.NODE_ENV === 'development'
      ? 'pk_test_2Ze4brO6LvxynAeKZUCneH9R'
      : 'pk_live_Aq6oBHPNQqo7tlvinR5zIbAs',
  image: '',
  billingAddress: true,
  zipCode: true,
  locale: 'auto',
  currency: 'USD',
  panelLabel: 'Pay {{amount}}',
});
